import React from "react";
import { Button } from "wbm-inputs";

export interface ICustomizeButtonProps {
  restrictedLink: string;
  restrictedMessage: string;
  preventPurchase?: boolean;
  permitPurchase?: boolean;
  productCustomizeUrl?: string;
  itemClicked?: () => void;
}

const CustomizeButton: React.FC<ICustomizeButtonProps> = (
  props: ICustomizeButtonProps
) => {
  return (
    <>
      {!props.preventPurchase && props.permitPurchase ? (
        <a
          href={props.productCustomizeUrl}
          className="wbm-button btn-link w-100"
          onClick={props.itemClicked}
        >
          {" "}
          <Button tabIndex={-1} className="col btn-primary medium">
            CUSTOMIZE
          </Button>
        </a>
      ) : props.preventPurchase ? (
        <div className="unavailable-container d-flex justify-content-center align-items-center">
          <div className="font-weight-bold account-unavailable">
            Item Is Currently Unvailable
          </div>
        </div>
      ) : (
        <div className="unavailable-container">
          <div className="font-weight-bold account-unavailable">
            {props.restrictedLink}
          </div>
          {props.restrictedMessage && (
            <div className="account-text">{props.restrictedMessage}</div>
          )}
        </div>
      )}
    </>
  );
};

export default CustomizeButton;
